import Icon from 'veui/components/Icon'

Icon.register({
  'flow-quit': {
    paths: [
      {
        d: 'M736 384A352.09 352.09 0 0159.67 521 351.9 351.9 0 01384 32a32 32 0 010 64 288 288 0 10288 288 32 32 0 0164 0zM672 63H512a32 32 0 000 64h82.85L360.32 361.42a32 32 0 0045.36 45.16L640 172.36V255a32 32 0 0064 0V95a32 32 0 00-32-32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
